import { Validator } from '@vista-digital/validator';
import { SeatSelectionRuleName } from '../../types/seat-selection-rule-name';
import { anySeatsUntilAisleAreSelected, Direction, seatOneSpaceAwayIsAvailable, seatTwoSpacesAwayIsSelected } from '../seat-gap-utils';
export const defaultGapBetweenSelectedSeatsRuleOptions = {
    allowGapsWithMultipleSeatsBetweenSelectedSeats: false
};
export const gapBetweenSelectedSeatsRuleOptionsValidator = Validator.object({
    allowGapsWithMultipleSeatsBetweenSelectedSeats: Validator.boolean()
});
const ruleName = SeatSelectionRuleName.CannotLeaveGapsBetweenSelectedSeats;
/**
 * Validates if the selected seats contain a single seat gap
 * between any contiguously selected seats.
 */
export const cannotLeaveGapsBetweenSelectedSeatsRule = (options) => {
    const mergedOptions = Object.assign(Object.assign({}, defaultGapBetweenSelectedSeatsRuleOptions), options);
    return {
        name: ruleName,
        validate: (data, selectedSeats) => {
            const valid = selectedSeats.every(seat => isSeatValid(data, selectedSeats, seat, mergedOptions));
            return {
                ruleName: ruleName,
                isValid: valid
            };
        }
    };
};
const isSeatValid = (data, selectedSeats, seat, options) => {
    if (options.allowGapsWithMultipleSeatsBetweenSelectedSeats) {
        const hasLeftSingleSeatGap = seatOneSpaceAwayIsAvailable(data, selectedSeats, seat.position, Direction.Left) &&
            seatTwoSpacesAwayIsSelected(data, selectedSeats, seat.position, Direction.Left);
        const hasRightSingleSeatGap = seatOneSpaceAwayIsAvailable(data, selectedSeats, seat.position, Direction.Right) &&
            seatTwoSpacesAwayIsSelected(data, selectedSeats, seat.position, Direction.Right);
        return !hasLeftSingleSeatGap && !hasRightSingleSeatGap;
    }
    const hasLeftGap = seatOneSpaceAwayIsAvailable(data, selectedSeats, seat.position, Direction.Left) &&
        anySeatsUntilAisleAreSelected(data, selectedSeats, seat.position, Direction.Left);
    const hasRightGap = seatOneSpaceAwayIsAvailable(data, selectedSeats, seat.position, Direction.Right) &&
        anySeatsUntilAisleAreSelected(data, selectedSeats, seat.position, Direction.Right);
    return !hasLeftGap && !hasRightGap;
};
